<template>
  <div class="bq-col-wrap" :class="{ mobile: isMobile }">
    <div class="bq-col-item">
      <header @click="toggle">
        <p>{{ title }}</p>
        <div
          class="bq-icon-plus"
          :class="{ focus: isToggle }"
          v-if="isMobile"
        ></div>
      </header>

      <ul :class="{ active: isToggle }">
        <li
          class="bq-links"
          v-for="item in list"
          :key="item.title"
          @click="handleClick(item)"
        >
          <span v-if="item.label">{{ item.label }}：</span>
          <!-- tel -->
          <a :href="`tel:+${item.title}`" v-if="item.isTel">{{ item.title }}</a>
          <!-- email -->
          <a :href="`mailto:${item.title}`" v-else-if="item.isEmail">
            {{ item.title }}
          </a>
          <!-- other -->
          <span v-else>{{ item.title }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import { isWirelessDevice } from '@/utils/utils.js';
export default {
  name: 'BQCol',

  props: {
    title: String,
    list: Array,
  },

  data() {
    return {
      isMobile: false,
      isToggle: false,
    };
  },

  created() {
    // this.isMobile = isWirelessDevice();
  },

  methods: {
    toggle() {
      this.isToggle = !this.isToggle;
    },

    handleClick(item) {
      if (item.path === this.$route.fullPath) {
        return;
      }
      this.$router.push(item.path);
    },
  },
};
</script>

<style lang="less" scoped>
@import './Col.less';
</style>
